export var StrategyAttributeDeviceName;
(function (StrategyAttributeDeviceName) {
    StrategyAttributeDeviceName["Browser"] = "browser";
    StrategyAttributeDeviceName["Mobile"] = "mobile";
    StrategyAttributeDeviceName["Desktop"] = "desktop";
    StrategyAttributeDeviceName["Server"] = "server";
    StrategyAttributeDeviceName["Watch"] = "watch";
    StrategyAttributeDeviceName["Embedded"] = "embedded";
})(StrategyAttributeDeviceName || (StrategyAttributeDeviceName = {}));
//# sourceMappingURL=strategy-attribute-device-name.js.map